import { useEffect } from 'react'
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'

const useSendPageViewToGTM = ({ pathname }) => {
  const sendDataToGTM = useGTMDispatch()

  useEffect(() => {
    setTimeout(() => {
      sendDataToGTM({ event: 'pageview', value: pathname })
    }, 500)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
}

export default useSendPageViewToGTM
